import React, { useEffect } from "react"
import Layout from "../components/layouts/layout"
import SEO from "../components/seo"
import "./style.scss"
const policyPage = ()=> {
  return (
    <Layout>
      <SEO title="使用条款" description="使用条款" />
      <div id="policyWrap">
        <div className="container policyMain">
          <div className="title_box">
            <h4>南回维度使用协议</h4>
            <p>最近更新日期：2025年07月14日</p>
          </div>
          <div className="text_details">
            <p>
              南回维度是一个商业平台,为商家提供设置网上商店并在网站上销售产品和服务的工具和技术。本《使用协议》（下称"<strong>使用协议</strong>"）描述了一些您使用南回维度服务时被禁止的活动。
            </p>
            <p>
              以下活动是被禁止或受限制的。以下活动类型具有代表性但并非穷尽。如果您不确定您的业务是否属于被禁止或受限制的业务,或对这些要求如何适用于您有任何疑问,请联系我们。
            </p>
            <p>
            <strong>1.儿童剥削：</strong>
              您不得提供与非法利用或滥用儿童权益相关的商品和服务,也不得发布、上传任何此类材料,包括但不限于虐待儿童或性虐待,或者以性方式展示、介绍儿童的图片或描述。
            </p>
            <p>
            <strong>2.骚扰、欺凌、诽谤和威胁：</strong>
              您不得提供骚扰、欺凌、诽傍或威胁特定个人的商品或服务,也不得发布、上传此类材料。
            </p>
            <p>
            <strong>3.恶意内容：</strong>
              您不得通过使用南回维度服务宣传或纵容基于种族、民族、肤色、国籍、宗教信仰、年龄、性别、性取向、残疾、健康状况或退伍军人身份或其他形式的歧视对人的暴力和仇恨行为,也不得发布上传此类材料。您不得使用我们的服务来纵容或支持任何有下述行为的组织,平台或个人：（i）宣传或纵容此类仇恨;或（ii）威胁或纵容以暴力达成某种目的。
            </p>
            <p>
            <strong>4.非法活动：</strong>

              您不得提供违反您经营或开展业务所在的司法管辖区法律的商品或服务,也不得发布上传此类材料。您提供的商品、服务及发布上传的材料亦不得帮助或宣传任何违反您经营或开展业务所在的司法管辖区法律的行为。
            </p>
            <p>
            <strong>5.知识产权：</strong>

              您不得侵犯个人或任何实体的版权、商标、商业机密或其他知识产权。未经合法权利人的事先授权,您不得使用本服务提供、发布、上传、展示或以其他方式提供任何商品、店铺服务或材料
            </p>
            <p>
            <strong>6.恶意和欺骗性的行为：</strong>

              您不得使用南回维度服务传播恶意软件或主机网络钓鱼页面。您不得进行损害或破坏南回维度及包括南回维度第三方合作者在内的其他主体的服务运营或其他基础设施的活动,也不得上传发布此类材料。您不得将本服务用于欺骗性的商业行为或其他任何非法或欺骗性行为。
            </p>
            <p>
            <strong>7.个人、机密信息和受保护的健康信息：</strong>

              您不得发布或上传任何包含个人身份信息,个人敏感信息或保密信息（如信用卡号码、保密国家身份证件号或账户密码）的材料,除非您已获得该信息所属权人或其他合法授权人的同意。您不得使用南回维度服务收集、存储或处理受《健康保险便利和责任法案》（"HIPAA"）或其他适用的关于健康隐私信息及其处理、使用、披露的法律法规所保护的的健康信息。
            </p>
            <p>
            <strong>8.禁止和限制物品：</strong>
              是指依据适用法律法规,被禁止销售的产品、服务、内容或材料,或在您的店铺所在地或销售地区需要相关政府机构颁发特别许可或执照才能销售的商品。您不得提供任何属于或看似属于禁止和限制物品的商品、服务或材料。
            </p>
            <p>
            <strong>9.安全与福祉：</strong>
              您不得提供或发布任何宣扬以下行为的商品、服务或材料,包括自残、自杀、饮食失调与身体形象扭曲、虐待动物、有害行为、危险活动或挑战、教唆杀人或伤害他人、危险或威胁性恶作剧,以及血腥、暴力或令人震惊及不安的内容。
            </p>
            <p>
            <strong>10.低俗语言：</strong>
              您不得发布或上传含有过度露骨性语言或叙述、严重粗俗用语或性暗示词汇的材料。
            </p>
            <p>
            <strong>11.垃圾邮件：</strong>
              您不得使用南回维度服务传输任何未经用户许可的商业电子信息。不得以任何方式促成或协助垃圾邮件的传播。
            </p>
            <p>
            <strong>12.黑客行为、病毒传播与网络攻击：</strong>
              不得在未获授权的情况下访问任何计算机或通信系统,包括用于提供南回维度服务的系统。不得故意传播计算机病毒、发起拒绝服务攻击,或以任何其他方式试图干扰南回维度服务、任何计算机、通信系统或网站的正常运行。不得试图访问或以其他方式干扰其他用户的账户或其对南回维度服务的使用。
            </p>
            <p>
            <strong>13.恐怖主义组织：</strong>
              您不得提供任何暗示或宣传支持、资助或参与恐怖主义组织的商品或服务,以及任何此类材料。
            </p>
            <p>
            <strong>14.诚信与真实性：</strong>
              无论是否有意,您不得提供可能对个人或社会造成重大危害的虚假材料。若材料包含可能造成伤害的虚假信息,例如某些健康相关内容、阴谋论、被篡改的媒体素材或对权威来源的歪曲描述,则将被视为不合格内容。我们要求您对使用人工智能生成（AIGC）或经过编辑、呈现逼真场景或人物的媒体进行明确标注。不得提供包含伪造权威来源、虚假危机事件,或将公众人物置于不实情境中的内容。我们不允许宣传或交易任何试图人为提升互动量的服务。
            </p>
            <p>
              如果您从事的活动违反了本使用协议（包括您在使用南回维度服务之外的活动）,南回维度有权随时不经通知删除任何材料,暂停或终止您的账户和您对南回维度服务的访问。
            </p>
            <p>
              南回维度有权,但非义务,随时监督或调查您上传的材料和使用南回维度服务的行为是否遵守本使用协议,或任何其他与南回维度达成的共识或协议（统称"协议"）。南回维度关于是否发生了违反本使用协议的行为的认定是最终且具有约束力的,南回维度将自行决定如何处理违反本使用协议的行为（包括不采取任何行动）。
            </p>

            <p>
              南回维度可随时修改本使用协议,包括在使用协议定义中定义的禁止和限制物品列表,并在以下网址发布修订版本<a href="https://onesolor.com/policy" target="_bank">https://onesolor.com/policy</a>。如您在本使用办议修订版生效后继续使用南回维度服务或访问您的账户,即表示您同意遵守本使用协议的最新版本。
            </p>

            <p>
              在本使用协议中使用但未定义的术语应该按其所在协议中的含义定义。
            </p>

            <p>
              如果您认为有使用我们服务的用户违反了此使用协议,请与我们联系。
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default policyPage
